/**
 * (c) 2026, Micro:bit Educational Foundation and contributors
 *
 * SPDX-License-Identifier: MIT
 */
import AnimationIcon, { AnimationIconProps } from "./AnimationIcon";

const CrossLedIcon = (props: AnimationIconProps) => {
  return (
    <AnimationIcon
      viewBox="0 0 23 22"
      baseCss={{ color: "brand2.500" }}
      {...props}
    >
      <path
        d="M5.70002 5H8.50002C8.70002 5 8.80002 5.2 8.80002 5.3V8.1C8.80002 8.3 8.60002 8.4 8.50002 8.4H5.70002C5.50002 8.4 5.40002 8.2 5.40002 8.1V5.3C5.40002 5.1 5.60002 5 5.70002 5Z"
        fill="currentColor"
      />
      <path
        d="M14.3 5H17.1C17.3 5 17.4 5.2 17.4 5.3V8.1C17.4 8.3 17.2 8.4 17.1 8.4H14.3C14.1 8.4 14 8.2 14 8.1V5.3C14 5.1 14.1 5 14.3 5Z"
        fill="currentColor"
      />
      <path
        d="M1.3 0.700427H4.1C4.3 0.700427 4.4 0.900427 4.4 1.00043V3.80043C4.4 4.00043 4.2 4.10043 4.1 4.10043H1.3C1.1 4.10043 1 3.90043 1 3.80043V1.00043C1 0.800427 1.2 0.600427 1.3 0.700427Z"
        fill="currentColor"
      />
      <path
        d="M18.6 0.700195H21.4C21.6 0.700195 21.7001 0.900195 21.7001 1.0002V3.8002C21.7001 4.0002 21.5 4.1002 21.4 4.1002H18.6C18.4 4.1002 18.3 3.9002 18.3 3.8002V1.0002C18.3 0.800195 18.4 0.700195 18.6 0.700195Z"
        fill="currentColor"
      />
      <path
        d="M5.70002 13.5996H8.50002C8.70002 13.5996 8.80002 13.7996 8.80002 13.8996V16.6996C8.80002 16.8996 8.60002 16.9996 8.50002 16.9996H5.70002C5.50002 16.9996 5.40002 16.7996 5.40002 16.6996V13.8996C5.40002 13.6996 5.60002 13.5996 5.70002 13.5996Z"
        fill="currentColor"
      />
      <path
        d="M14.3 13.5996H17.1C17.3 13.5996 17.4 13.7996 17.4 13.8996V16.6996C17.4 16.8996 17.2 16.9996 17.1 16.9996H14.3C14.1 16.9996 14 16.7996 14 16.6996V13.8996C14 13.6996 14.1 13.5996 14.3 13.5996Z"
        fill="currentColor"
      />
      <path
        d="M18.6 17.9004H21.4C21.6 17.9004 21.7001 18.1004 21.7001 18.2004V21.0004C21.7001 21.2004 21.5 21.3004 21.4 21.3004H18.6C18.4 21.3004 18.3 21.1004 18.3 21.0004V18.2004C18.3 18.0004 18.5 17.9004 18.6 17.9004Z"
        fill="currentColor"
      />
      <path
        d="M9.89997 9.2998H12.7C12.9 9.2998 13 9.4998 13 9.5998V12.3998C13 12.5998 12.8 12.6998 12.7 12.6998H9.89997C9.69997 12.6998 9.59998 12.4998 9.59998 12.3998V9.5998C9.59998 9.3998 9.79997 9.2998 9.89997 9.2998Z"
        fill="currentColor"
      />
      <path
        d="M1.3 17.9004H4.1C4.3 17.9004 4.4 18.1004 4.4 18.2004V21.0004C4.4 21.2004 4.2 21.3004 4.1 21.3004H1.3C1.1 21.3004 1 21.1004 1 21.0004V18.2004C1 18.0004 1.2 17.9004 1.3 17.9004Z"
        fill="currentColor"
      />
    </AnimationIcon>
  );
};

export default CrossLedIcon;
